<template>
  <div class="page">
<!--    <loading :active.sync="isLoading" :loader="'dots'" v-if="!($route.path === '/account/login' || $route.path === '/main/receipt')"></loading>-->
    <header-bar v-bind:layoutState="layoutState"
                v-bind:userDataState="userDataState"
                @update="fnReload">
    </header-bar>

    <div class="tab_bar" v-if="layoutState.isTab && layoutState.tabType === $ConstCode.TAB_TYPE.FINDID">
      <button class="on">아이디 찾기</button>
      <button @click="$router.replace('/account/findPWD')">비밀번호 찾기</button>
    </div>
    <div class="tab_bar" v-if="layoutState.isTab && layoutState.tabType === $ConstCode.TAB_TYPE.FINDPWD">
      <button @click="$router.replace('/account/findID')">아이디 찾기</button>
      <button class="on">비밀번호 찾기</button>
    </div>
    <transition v-bind:name="transitionName"
                v-on:before-leave="transition"
                v-bind:mode="transitionMode">
      <keep-alive :include="keepAlive">
        <router-view :key="$route.fullPath.replace('#', '')"/>
      </keep-alive>
    </transition>
    <footer-bar v-bind:isFooter="layoutState.isFooter" v-bind:fullPath="$route.fullPath"></footer-bar>

    <modal-container
      v-if="modalState.isModal"
      v-bind:modalName="modalState.modalName"
      v-bind:modalTitle="modalState.modalTitle"
      v-bind:type="modalState.type"
      v-bind:data="modalState.data"
      v-bind:isShow="isShow"
      v-bind:zIndex="zIndex"
      v-bind:callBack="modalState.callBack"
      v-on:close="fnCloseModal"
    />
    <modal-alert-container
      v-if="modalAlertState.isModalAlert"
      v-bind:type="modalAlertState.type"
      v-bind:data="modalAlertState.data"
      v-bind:zIndex="zIndex"
      v-bind:callBack="modalAlertState.callBack"
      v-on:close="fnCloseModal"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import HeaderBar from './HeaderBar'
import FooterBar from "./FooterBar";
import ModalLayoutMixin from "./ModalLayoutMixin";
import ModalAlertLayoutMixin from "./ModalAlertLayoutMixin";

export default {
  mixins: [ModalLayoutMixin, ModalAlertLayoutMixin],
  name: 'ContentView',
  components: {
    Loading,
    'header-bar': HeaderBar,
    'footer-bar': FooterBar,
  },
  computed: {
    layoutState: function () {
      return this.$store.getters['layout/getLayout']
    },
    userDataState: function () {
      return this.$store.getters['account/getUserData']
    },
    messageStatus: function () {
      return this.$store.getters['pageStatus/getMessageStatus']
    },
    isLoading: function () {
      return this.$store.getters['layout/getLoading']
    }
  },
  data() {
    return {
      keepAlive: ['faq-index'],
      transitionName: '',
      transitionMode: '',
      toPage: '',
      fromPage: '',
      isNoPage: false
    }
  },
  watch: {
    $route(to, from) {
      this.isNoPage = false
      this.toPage = to.name
      this.fromPage = from.name
      // main-store-view
      // let toPage = to.query.routerPage || to.meta.page
      // let fromPage = from.query.routerPage || from.meta.page
      // let toPage = to.meta.page
      // let fromPage = from.meta.page
      if (to.name?.indexOf('main') > -1) {
        this.keepAlive = []
      }
      this.transitionName = 'fade2'
      // this.transitionName = toPage === fromPage ? 'fade2' : toPage > fromPage ? 'next' : 'prev'
      // this.transitionName = toPage > fromPage ? 'next' : 'prev'
      this.transitionMode = 'out-in'
    },
    messageStatus(val) {
      if (!val) this.chatComplete()
    }
  },
  methods: {
    transition: function () {
      // this.isNoPage = (this.toPage === 'main-store-view' || this.fromPage === 'main-store-view')
    },
    fnReload: function () {
      window.location.reload()
    },
    chatComplete: async function () {
      const params = {}
      params.serviceType= this.$store.getters['pageStatus/getMessageServiceType']
      params.userNo = this.userDataState.userNo
      params.userMessageToken = this.$store.getters['pageStatus/getUserMessageToken']
      params.messageType = 10
      params.sendType = 1
      params.message = ''
      console.log(params)
      await this.$CommonSvc.send(params)
    }
  }
}
</script>
<style lang="scss">
.loader-enter-active
.loader-leave-active {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 100;
  transition: all 1s;
}

.loader-enter
.loader-leave-to {
  opacity: 0;
  z-index: -1;
}


.fade2-enter-active,
.fade2-leave-active {
  transition: all 0.3s;
}

.fade2-enter,
.fade2-leave-to {
  opacity: 0
}

.page1 {
  min-height: 100%;
  display: grid;
  grid-template: "main";
  flex: 1;
  background-color: white;
  position: relative;
  /*overflow-x: hidden;*/
}

.page1.noPage {
  display: block;
  /*overflow-x: hidden;*/
}

.page1 > * {
  grid-area: main;
  position: relative;
}

/*.page1 > *:not(.login) {*/
/*  background-color: white;*/
/*}*/
.pos > .inner {
  background-color: white;
}

.page1 > :first-child {
  z-index: 2004; /* Prevent flickering on first frame when transition classes not added yet */
}

/*.next-leave-to {*/
/*  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);*/
/*  z-index: 0;*/
/*}*/

/*.next-enter-to {*/
/*  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);*/
/*  z-index: 2005;*/
/*}*/

/*.prev-leave-to {*/
/*  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);*/
/*  z-index: 2005;*/
/*}*/

/*.prev-enter-to {*/
/*  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);*/
/*  z-index: 0;*/
/*}*/


.next-leave-to {
  animation: leaveToTop 800ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromBottom 800ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 2005;
}

.prev-leave-to {
  animation: leaveToBottom 800ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 2005;
}

.prev-enter-to {
  animation: enterFromTop 800ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(-25%);
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    -webkit-transform: translateX(-25%);
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    filter: brightness(0.5);
  }
  to {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}


@keyframes leaveToTop {
  from {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  to {
    -webkit-transform: translateY(-25%);
    transform: translateY(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromTop {
  from {
    -webkit-transform: translateY(-25%);
    transform: translateY(-25%);
    filter: brightness(0.5);
  }
  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes leaveToBottom {
  from {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  to {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromBottom {
  from {
    -webkit-transform: translateY(100%);
    transform: translateY(100%);
    filter: brightness(0.5);
  }
  to {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.vld-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.vld-background {
  backdrop-filter: none !important;
  width: 100%;
  height: 100%;
}
.vld-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -120px;
  margin-left: -30px;
}
</style>
